import { reflectKeys } from "@utils/key.reflactor";
import appConfigs from "@configs/app";

export const NAMESPACE = {
  FORUM: "forum",
  AUTH: "auth",
};
export const GROUP_TYPE = {
  STUDENTGROUP: "STUDENT_GROUP",
};

export const RESOURCE_TYPE = {
  POST: "POST",
};

export const GAME_IMAGE_TYPE = {
  GAME_STORY_BACKGROUND: "GAME_STORY_BACKGROUND",
  ACHIEVEMENT_ICON: "ACHIEVEMENT_ICON",
  GAME_STORY_ICON: "GAME_STORY_ICON",
  ACHIEVEMENT_BACKGROUND: "ACHIEVEMENT_BACKGROUND",
  GAME_AVATAR_IMAGE: "GAME_AVATAR_IMAGE",
  DIGITAL_BADGE_ICON: "DIGITAL_BADGE_ICON",
};

export const EARLY_SUBMISSION_BONUS_VALUES = reflectKeys(["0", "5", "10", "25", "50", "100"]);

export const LATE_SUBMISSION_PENALTY_VALUES = reflectKeys(["0", "5", "10", "25", "50", "100"]);

export const RETRY_XP_PENALTY_VALUES = reflectKeys(["0", "5", "10", "25", "50"]);

export const OPEN_HINT_XP_PENALTY_VALUES = reflectKeys(["0", "5", "10", "25", "50"]);

export const EXCEED_QUIZ_TIME_XP_PENALTY_VALUES = reflectKeys(["0", "5", "10", "25", "50"]);

export const STREAK_BONUS_VALUES = reflectKeys([...Array(21).keys()].map((i) => String(i * 5))); // 0, 5, 10, ..., 100

export const QUIZ_RETRY_XP_PENALTY_VALUES = reflectKeys(["0", "5", "10", "25", "50"]);

export const FILTER_LIST = {
  ALL: { value: "ALL", label: "gamification_filter_option_all" },
  WITH_CONDITIONS: { value: "WITH_CONDITIONS", label: "gamification_filter_option_with_condition" },
  WITHOUT_CONDITIONS: {
    value: "WITHOUT_CONDITIONS",
    label: "gamification_filter_option_without_condition",
  },
};

export const STATUS_FILTER_LIST = {
  ALL: { value: "ALL", label: "gamification_filter_option_all" },
  AWARDED: { value: "AWARDED", label: "gamification_game_info_achievement_awarded_label" },
  NOT_AWARDED: {
    value: "NOT_AWARDED",
    label: "gamification_game_info_achievement_not_awarded_label",
  },
};

export const MAX_LENGTH = {
  TITLE: 250,
  DESCRIPTION: 2000,
  GAME_STORY_TITLE: 250,
  ACHIEVEMENT_TITLE: 250,
  CHOICE: 50,
};

export const MAX_LIMIT = {
  GAME_AWARD_LIST: 50,
  GAME_CHOICE_LIST: 26,
};

export const GAME_AWARD_TYPE = {
  GAME_STORY: "GAME_STORY",
  COLLECTIBLE: "COLLECTIBLE",
  ACHIEVEMENT: "ACHIEVEMENT",
  GAME_AVATAR: "GAME_AVATAR",
  DIGITAL_BADGE: "DIGITAL_BADGE",
} as const;

export const CONDITION_TYPE = {
  RESOURCE_STARTS: "RESOURCE_START",
  RESOURCE_COMPLETE: "RESOURCE_COMPLETION",
  LEVEL_UP: "LEVEL_UP",
  QUIZ_MARK_AWARD: "RESOURCE_SCORE",
  GAME_AWARD: "GAME_AWARD",
  GAME_CHOICE: "GAME_CHOICE",
  QUIZ_RANK: "QUIZ_RANK",
};

export const FILE_SIZE_LIMIT = "10";

export const GAME_CHOICE_TYPE = reflectKeys(["SELECT", "TEXT_INPUT"]);

export const AUDIO_OPTION = {
  NO: "NO",
  DEFAULT: "DEFAULT",
  CUSTOM: "CUSTOM",
};

export const S3_GAME_STORY_DEFAULT_AUDIO_FILE_NAME = "DEFAULT_GAME_STORY_AUDIO.mp3";
export const S3_ACHIEVEMENT_DEFAULT_AUDIO_FILE_NAME = "DEFAULT_ACHIEVEMENT_AUDIO.mp3";

export const GAMIFICATION_AUDIO_FILE_TYPE = {
  GAME_STORY_AUDIO: "GAME_STORY_AUDIO",
  ACHIEVEMENT_AUDIO: "ACHIEVEMENT_AUDIO",
};

export const S3_GAME_STORY_DEFAULT_AUDIO_URL = `${appConfigs.vleDomain}/gamification/audio/${S3_GAME_STORY_DEFAULT_AUDIO_FILE_NAME}`;

export const S3_ACHIEVEMENT_DEFAULT_AUDIO_URL = `${appConfigs.vleDomain}/gamification/audio/${S3_ACHIEVEMENT_DEFAULT_AUDIO_FILE_NAME}`;
